class shopifyMoney {
   init(){
     var Shopify = window.Shopify || {};


     window.Shopify.getSymbol = function(){
      var symb = '€';

      if(Shopify.currency){
        if(Shopify.currency.active != 'EUR') {
          symb = Shopify.currency.active;
        }
        if(symb=='USD') symb = '$';
        if(symb=='GBP') symb = '£';
        if(symb=='EUR') symb = '€';
        if(symb=='JPY') symb = '¥';
        if(symb=='CNY') symb = '¥'; 
        if(symb=='KRW') symb = '₩';
        if(symb=='RUB') symb = '₽';
        if(symb=='SEK') symb = 'kr';
        if(symb=='NOK') symb = 'kr';
        if(symb=='DKK') symb = 'kr';
        if(symb=='ISK') symb = 'kr';
        if(symb=='CHF') symb = 'CHF';
        if(symb=='CZK') symb = 'Kč';
        if(symb=='PLN') symb = 'zł';
        if(symb=='HUF') symb = 'Ft';
        if(symb=='BRL') symb = 'R$';
        if(symb=='CAD') symb = '$';
        if(symb=='AUD') symb = '$';
        if(symb=='NZD') symb = '$';
        if(symb=='SGD') symb = '$';
        if(symb=='HKD') symb = '$';
        if(symb=='TWD') symb = 'NT$';
        if(symb=='THB') symb = '฿';
        if(symb=='PHP') symb = '₱';
        if(symb=='MYR') symb = 'RM';
        if(symb=='IDR') symb = 'Rp';
        if(symb=='INR') symb = '₹';
        if(symb=='TRY') symb = '₺';
        if(symb=='ILS') symb = '₪';
        if(symb=='SAR') symb = '﷼';
        if(symb=='AED') symb = 'د.إ';
        if(symb=='QAR') symb = '﷼';
        if(symb=='KWD') symb = 'د.ك';
        if(symb=='BHD') symb = 'د.ب';
      }
      return symb;
    }

    window.Shopify.money_format = `{{amount_no_decimals}} ${window.Shopify.getSymbol()}`; // Default format

     // ---------------------------------------------------------------------------
     // Money format handler
     // ---------------------------------------------------------------------------
//     window.Shopify.money_format = "{{amount_no_decimals_with_space_separator}}€";
     window.Shopify.formatMoney = function(cents, format) {
       if (typeof cents == 'string') { cents = cents.replace('.',''); }
       var value = '';
       var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
       var formatString = (format || this.money_format);
 
       function defaultOption(opt, def) {
         return (typeof opt == 'undefined' ? def : opt);
       }
 
       function formatWithDelimiters(number, precision, thousands, decimal) {
         precision = defaultOption(precision, 2);
         thousands = defaultOption(thousands, ',');
         decimal   = defaultOption(decimal, '.');
 
         if (isNaN(number) || number == null) { return 0; }
 
         number = (number/100.0).toFixed(precision);
 
         var parts   = number.split('.'),
         dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
         cents   = parts[1] ? (decimal + parts[1]) : '';
 
         return dollars + cents;
       }
 
       switch(formatString.match(placeholderRegex)[1]) {
         case 'amount':
         value = formatWithDelimiters(cents, 2);
         break;
         case 'amount_no_decimals':
         value = formatWithDelimiters(cents, 0);
         break;
         case 'amount_with_comma_separator':
         value = formatWithDelimiters(cents, 2, '.', ',');
         break;
         case 'amount_no_decimals_with_comma_separator':
         value = formatWithDelimiters(cents, 0, '.', ',');
         break;
         case 'amount_no_decimals_with_space_separator':
         value = formatWithDelimiters(cents, 0, ' ');
         break;
       }

       value = value.replaceAll(',', ' ');
      //  value = value.replaceAll('.', ' ');

       return formatString.replace(placeholderRegex, value);
     };
 
   }
 }
 export default shopifyMoney;
 